import { createOutlineIcon } from "../createIcon";

export const SearchOutlineIcon = createOutlineIcon(
  <>
    <path d="M16.927 17.04 20.4 20.4m-1.12-8.96a7.84 7.84 0 1 1-15.68 0 7.84 7.84 0 0 1 15.68 0Z" />
  </>,
  "SearchOutlineIcon"
);
